import { on } from "@ngrx/store";

import { JobEstimateActions } from "../job-estimate/job-estimate.actions";
import { JobFinancialsActions } from "../job-financials/job-financials.actions";
import { JobToolState } from "../job-tool.reducer";

export const jobFilesReducers = [
  on(JobEstimateActions.openDocumentActionsButtonClicked, (state: JobToolState, { artifactId }): JobToolState => {
    return {
      ...state,
      actionsMenuArtifactId: artifactId,
    }
  }),
  on(
    JobEstimateActions.sendDocumentButtonClicked,
    (state: JobToolState, { artifactId }): JobToolState => {
        return {
          ...state,
          documentsSending: {
            ...state.documentsSending,
            [ artifactId ]: true,
          }
        }
      },
  ),
  on(
    JobEstimateActions.sendDocumentSuccess,
    JobEstimateActions.sendDocumentError,
    JobFinancialsActions.sendDocumentSuccess,
    JobFinancialsActions.sendDocumentError,
    (state: JobToolState, { artifactId }): JobToolState => {

      const documentsSending = { ...state.documentsSending };

      delete documentsSending[artifactId];

      return {
        ...state,
        documentsSending,
      }
    },
  ),
];
